import { createSelector } from '@reduxjs/toolkit';
import { employeeInterview } from './employee-interview';

export const employeeInterviewUuid = createSelector(employeeInterview, function (employeeInterview) {
  if (employeeInterview) {
    return employeeInterview.uuid;
  }
  return '';
});
